import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@gfc-flash/service-translate';
import { TextCaseTransformPipe } from '@gfc-flash/pipe-text-case-transform';
import { TextCaseTransformEnum } from '@gfc-flash/package-text-case-transform';

/**
 * @description Angular title strategy that translates route titles before applying title case.
 */
@Injectable({ providedIn: 'root' })
export class TranslatedTitleStrategy extends TitleStrategy {
  private readonly title: Title = inject(Title);
  private readonly translateService: TranslateService =
    inject(TranslateService);
  constructor() {
    super();
  }

  /**
   * @description Builds, translates and writes the browser title for the active route snapshot.
   */
  override updateTitle(snapshot: RouterStateSnapshot): void {
    const rawTitle = this.buildTitle(snapshot);
    if (rawTitle) {
      let translatedTitle = this.translateService.instant(rawTitle);
      translatedTitle = new TextCaseTransformPipe().transform(
        translatedTitle,
        TextCaseTransformEnum.TITLE_CASE,
      );
      this.title.setTitle(translatedTitle);
    }
  }
}
